import { BodyContent } from './layout/body'
import { HeadContent } from './layout/head'

export const ConsultationContent = () => {
  return (
    <div>
      <HeadContent />
      <BodyContent />
    </div>
  )
}
